var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"align-center"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-tune")]),_c('span',{staticClass:"ml-2"},[_vm._v("Inställningar")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }